import { DashboardType } from "@doitintl/cmp-models";
import orderBy from "lodash/orderBy";

import type { Dashboard } from "../../../Context/useDashboardsContext";

const getDashboardOrderByType = (dashboard: Dashboard) => {
  switch (dashboard.dashboardType) {
    case DashboardType.Pulse:
      return 1;
    case DashboardType.AwsLens:
    case DashboardType.SaaSAwsLens:
      return 2;
    case DashboardType.GcpLens:
    case DashboardType.SaaSGcpLens:
      return 3;
    case DashboardType.BqLens:
      return 4;
    case DashboardType.GkeLensV2:
      return 5;
    case DashboardType.AzureLens:
      return 6;
    case DashboardType.EKSLens:
      return 7;
    case DashboardType.AWSMAPLens:
      return 8;
    case DashboardType.KubernetesLens:
      return 9;
    default:
      return 10;
  }
};

export function sortDashboardsByType(dashboards: Dashboard[]) {
  return orderBy(dashboards, (dashboard) => getDashboardOrderByType(dashboard), ["asc"]);
}
